'use client'

import { useEffect } from 'react'
import { reportError } from '@/lib/errors/report'

/**
 * Catches errors no boundary ever sees: unhandled promise rejections and
 * stray global errors. These must never escalate to a boundary — a rogue
 * promise blanking the whole app would be worse than the original bug.
 */
export function GlobalErrorListener() {
  useEffect(() => {
    const onRejection = (event: PromiseRejectionEvent) => {
      reportError(event.reason, { source: 'unhandledrejection' })
    }
    const onError = (event: ErrorEvent) => {
      reportError(event.error ?? event.message, { source: 'window.onerror' })
    }
    window.addEventListener('unhandledrejection', onRejection)
    window.addEventListener('error', onError)
    return () => {
      window.removeEventListener('unhandledrejection', onRejection)
      window.removeEventListener('error', onError)
    }
  }, [])

  return null
}
